// src/App.js
//import React, { useEffect } from 'react';
//import { HashRouter as Router, Routes, Route,Outlet  } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
/* import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"; */
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
//import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AlbumList from './components/AlbumList';
import ThumbnailGallery from './components/ThumbnailGallery';
import Carousel from './admin/carousel';
import CourseManager from './admin/CourseManager';
import AdminLogin from './admin/adminlogin';
import Register from './admin/Register';
import AdminLiteDashboard from './admin/AdminLiteDashboard';
import Notification from './admin/NotificationPage';
import NotificationDetail from './NotificationDetail';
import Advirtise from './admin/Advertise';
import Inquiry from './admin/inquiry'; 
import Callback from './admin/callback';
import Album from './admin/album';
import Gallery from './admin/manage_gallery';
import Video from './admin/upload_video';
import VideoG from './components/video';
import AddStaff from './admin/AddStaff';
import OurTeam from './components/staff';
import CourseDetail from './components/course_detail';
import ContactDetails from './admin/contact_details';
import CoursePage from './admin/CoursePage';
import AcademicYearPage from './admin/AcademicYearPage';
//import FeeCategory from './admin/FeeCategoryPage';
import FeeCategoryPage from './admin/FeeCategoryPage';
import ClassPage from './admin/ClassPage';
import AdmissionPage from './admin/AdmissionPage';
import RoutePage from './admin/RoutePage';
import Students from './admin/StudentsPage';
import EditStudentPage from './admin/EditStudentPage';
//import Navigation from './components/Navigation';
import FeeList from './admin/FeeListPage';
import PaymentPage from './admin/PaymentPage';
import PromotePage from './admin/PromotePage';
import FeeReport from './admin/FeeReportPage';
import ChatBot from './chatbot/ChatBot';
//import ExamTypeManager from './admin/ExamTypeManager'; // make sure this path is correct
import Subjects from './admin/Subjects';
//import MarksManager from './admin/MarksManager';
//import MarksList from './admin/MarksList';
import ExamPage from './admin/ExamPage';
import ExamPageList from './admin/ExamsList';
import MarksListPage from './admin/MarksListPage';
import AssignSubjects from './admin/AssignSubjects';
import MarksEditPage from './admin/MarksEditPage';
import AboutUsPage from './admin/AboutUsPage';
import SectionAdmin from './admin/SectionAdmin';
import Facilities from "./components/Facilities";
import Services from './components/Services';
import NotificationForm from './admin/NotificationForm';
import ChangePassword from './admin/ChangePassword';
import AbsentSMS from './admin/AbsentSMSPage';
import FeeBalance from './admin/FeeBalanceSMS';
import KannadaNotification from './admin/NotificationKannada';
import Section from './admin/AddSectionPage';
import ChairmanDashboard from './admin/SuperadminDashboard';
import SuperAdminDashboard from './super_admin/SuperAdminLiteDashboard';
import ConcessionPage from './admin/ConcessionPage';
import Registration from './components/Registration';
//import StudentLogIn from './pages/StudentLogIn';
import StudentLogIn from './pages/StudentLogin';
import StudentDashboard from './pages/StudentDashboard';
import HallTicket from './pages/HallTicket';
import ViewApplication from './admin/ViewApplication';
import StaffLiteDashboard from './staff/StaffLiteDashboard';
import StaffHome from './staff/StaffHome';
import HomeWorkPage from "./staff/HomeWorkPage";
import HomeWorkSMS from "./staff/SendHomeWorkSMS";
import ClassStudentList from "./staff/ClassStudentList";
import ExamHallTicketPage from "./admin/ExamHallTicketPage";
function App() {
  /* useEffect(() => {
    // Disable right-click across the application
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    // Add the event listener when the component mounts
    document.addEventListener('contextmenu', handleContextMenu);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []); */
  return (
    <Router>
      <Routes>
    {/*   <Navbar /> */}
     {/*  <Routes> */}
        {/* <Route path="/" element={<Home />} /> */}
        <Route element={<Layout/>}>
          {/* <Navbar/> */}
         
          <Route path="/" element={<Home />} />
          <Route path="/:id" element={<Home />} />  {/* Dynamic route for advertisement ID */}
        {/* Fallback route to redirect to home if no route matches */}
        <Route path="*" element={<Home />} />
        </Route>
        <Route element={<Layout/>}>
        <Route path="/about-us" element={<About />} />        
        </Route>
        <Route element={<Layout/>}>
        <Route path="/facilities" element={<Facilities />} />
        <Route path="/registration" element={<Registration />} />
        </Route>        
        <Route element={<Layout/>}>
        <Route path="/courses" element={< Services />} />
        </Route>
        <Route element={<Layout/>}>
        <Route path="/contact" element={<Contact />} />
       



        </Route>
        {/* =========================================
HALL TICKET
========================================= */}
<Route
   path="/student/hallticket/:id"
  element={<HallTicket />}
/>
 <Route
  path="/student-login"
  element={<StudentLogIn />}
/>
{/* =========================================
STUDENT DASHBOARD
========================================= */}
<Route
  path="/student-dashboard"
  element={<StudentDashboard />}
/>
        <Route element={<AdminLiteDashboard/>}>
        <Route path="/admin/carousel" element={<Carousel />} />
        </Route>
        <Route element={<AdminLiteDashboard/>}>
        <Route path="/admin/gallery" element={<Gallery />} />
        </Route>
        <Route element={<AdminLiteDashboard/>}>
        <Route path="/admin/courses" element={<CourseManager />} />
        </Route>
        <Route exact path="/admin/login" element={<AdminLogin/>} />
        <Route path="/admin/register" element={<Register/>} />
        <Route path="/admin/home" element={<AdminLiteDashboard />} />
        <Route path="/super_admin/home" element={<SuperAdminDashboard />} />
        <Route element={<AdminLiteDashboard/>}>
        <Route path="/admin/notifications" element={<Notification />} />
        <Route path="/admin/notifications/:notificationId" element={<Notification />} />
        </Route>
        <Route element={<Layout/>}>
        <Route path="/notification-detail/:title" element={<NotificationDetail />} />
        </Route>
        <Route element={<AdminLiteDashboard/>}>
        <Route path="/admin/advirtise" element={<Advirtise />} />
        </Route>
        <Route element={<AdminLiteDashboard/>}>
        <Route path="/admin/album" element={<Album />} />
        </Route>

        <Route element={<AdminLiteDashboard/>}>
        <Route path="/admin/inquiry" element={<Inquiry />} />
        </Route>
        <Route element={<AdminLiteDashboard/>}>
        <Route path="/admin/callback" element={<Callback />} />
        </Route>
        <Route element={<AdminLiteDashboard/>}>
        <Route path="/admin/video" element={<Video />} />
        </Route>
        <Route element={<Layout/>}>
        <Route path="/photo-gallery" element={<AlbumList />} />
        <Route path="/photo-gallery/:albumId" element={<ThumbnailGallery />} />
        <Route path="/video-gallery" element={<VideoG />} />
        <Route path="/video-gallery/:event_id" element={<VideoG />} />
        </Route>
        <Route element={<AdminLiteDashboard/>}>
        <Route path="/admin/addstaff" element={<AddStaff />} />
        </Route>
        <Route element={<Layout/>}>
        <Route path="/our-team" element={<OurTeam />} />
        </Route>
        <Route element={<Layout/>}>
        <Route path="/course/:id" element={<CourseDetail />} />
        </Route>
        <Route element={<AdminLiteDashboard/>}>
        <Route path="/admin/contact-detail" element={<ContactDetails />} />
        </Route>
        <Route element={<AdminLiteDashboard/>}>
        <Route path="/admin/coursespage" element={<CoursePage />} />
        </Route>
        {/* <LocalizationProvider dateAdapter={AdapterDayjs}> */}
        <Route element={<AdminLiteDashboard/>}>
        <Route path="/admin/academicyearpage" element={<AcademicYearPage />} />
        </Route>
        <Route element={<AdminLiteDashboard/>}>
        <Route path="/admin/feecategory" element={<FeeCategoryPage />} />
        </Route>
        <Route element={<AdminLiteDashboard/>}>
        <Route path="/admin/class" element={<ClassPage />} />
        </Route>
        <Route element={<AdminLiteDashboard/>}>
        <Route path="/admin/admission" element={<AdmissionPage />} />
        </Route>
        <Route element={<AdminLiteDashboard/>}>
        <Route path="/admin/route" element={<RoutePage />} />
        <Route path="/students" element={<Students />} />
        <Route path="/fee-payments" element={<FeeList />} />
        <Route path="/PaymentPage/:studentId" element={<PaymentPage />} />
        <Route path="/edit-student/:studentID" element={<EditStudentPage />} />
        <Route path="/admin/promote" element={<PromotePage />} />
        <Route path="/fee-report" element={<FeeReport />} />


        
        {/* <Route path="/admin/examtype" element={<ExamTypeManager />} /> */}
        <Route path="/admin/subject" element={<Subjects />} />
        <Route path="/admin/assignsubject" element={<AssignSubjects />} />
        {/* <Route path="/admin/marks" element={<MarksManager />} /> */}
        <Route path="/admin/sendmessage" element={<NotificationForm />} />
        <Route path="/admin/exampage" element={<ExamPage />} />
        <Route path="/admin/examlist" element={<ExamPageList />} />
        <Route path="/admin/markspagelist" element={<MarksListPage />} />
        <Route path="/admin/markseditpage" element={<MarksEditPage />} />
        <Route path="/admin/aboutuspage" element={<AboutUsPage />} />
        <Route path="/admin/sections/:slug" element={<SectionAdmin />} />
      <Route path="/admin/change-password" element={<ChangePassword/>} />
      <Route path="/admin/send-absent" element={<AbsentSMS/>} />
      <Route path="/admin/send-balance" element={<FeeBalance/>} />
      <Route path="/admin/sendkmessage" element={<KannadaNotification />} />
      </Route>
       <Route element={<AdminLiteDashboard/>}>
        <Route path="/admin/section" element={<Section />} />
        <Route path="/concessions" element={<ConcessionPage />} />
<Route
    path="/admin/exam-hall-ticket"
    element={<ExamHallTicketPage />}
/>
        </Route>
        <Route element={<AdminLiteDashboard />}>
  <Route
    path="/admin/view-applications"
    element={<ViewApplication />}
  />
</Route>
<Route element={<SuperAdminDashboard/>}>
       <Route path="/superadmin-dashboard" element={<ChairmanDashboard />} />
       <Route path="/admin/SuperadminDashboard" element={<ChairmanDashboard />} />
       <Route path="/admin/superchange-password" element={<ChangePassword/>} />
        </Route>
{/* <Route element={<StaffLiteDashboard/>}>
 <Route path="/staff" element={<StaffLiteDashboard/>}/> */}
 <Route element={<StaffLiteDashboard/>}>

<Route
path="/staff/home"
element={<StaffHome/>}
/>
<Route path="/staff/markspagelist" element={<MarksListPage />} />
<Route path="/staff/markseditpage" element={<MarksEditPage />} />
<Route
path="/staff/homework"
element={<HomeWorkPage/>}
/>
<Route
path="/staff/homeworksms"
element={<HomeWorkSMS/>}
/>
 <Route
        path="/staff/progress-report"
        element={<ClassStudentList />}
    />
</Route>
       
       {/*  </LocalizationProvider> */}
      {/* </Routes> */}
      {/* <Footer /> */}
      </Routes>
    </Router>
  );
}
// Layout component to conditionally render Navbar and Footer
const Layout = () => {
  return (
      <>
          <Navbar /> {/* Include Navbar */}
          <main>
              <Outlet /> {/* This will render the child routes */}
          </main>
          <ChatBot /> {/* ⬅️ Add this */}
          <Footer /> {/* Include Footer */}
      </>
  );
};
export default App;